import { Endpoints } from "services/api";
import { getFetch } from "@wexinc/wex-common-web";
import { Role } from ".";

const apiRoot = "roles";

const { get } = getFetch(Endpoints.apiRoot);

function getAllRoles(): Promise<Role[]> {
  return get({
    relativeRoute: `${apiRoot}/all`,
  });
}

export { getAllRoles };
